import { render } from "./PfSenseRecovery.vue?vue&type=template&id=4fd29eb2&scoped=true"
import script from "./PfSenseRecovery.vue?vue&type=script&lang=js"
export * from "./PfSenseRecovery.vue?vue&type=script&lang=js"

import "./PfSenseRecovery.vue?vue&type=style&index=0&id=4fd29eb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fd29eb2"

export default script